/**
 * External Dependencies
 */
import 'jquery';
import 'bootstrap';
import 'jquery-match-height';
import { nodeName } from 'jquery';
import 'slick-carousel';

$(document).ready(() => {
  $(".navbar-toggler").click( () => {
   if ( $( '#navbarNavDropdown' ).hasClass( "show" ) ) {
      $(".link-technology").css("display", "none");
   } else {
      $(".link-technology").css("display", "flex");
   }
  })

  $('#menu-item-dropdown-214').click( (e) => {
      e.preventDefault();

      if ($(window).width() > 992) {
         window.location.href = $(e.target).attr('href');
      }
  });

  if ($(window).width() < 992) {

      $('.dropdown-toggle').click ( (e) => {
        // e.preventDefault();

      })

      $('.dropdown-toggle').append ( $('<span class="showDropdown2"></span>') );
      $('.showDropdown2').css ({
         "position": "absolute",
         "right" : "0",
         "top": 0,
         "height": "50px",
         "width": "35%",
         "z-index": "999"
      });

      $('.dropdown-toggle').append ( $('<span class="showDropdown1"></span>') );
      $('.showDropdown1').css ({
         "position": "absolute",
         "left" : "0",
         "top": 0,
         "height": "50px",
         "width": "65%",
         "z-index": "999"
      });

      $('.showDropdown1').click ( () => {
         window.location.href = $('.dropdown-toggle').attr('href');
      })

      if ($(window).width() > 576 && $(window).width() < 992) {
         $('.showDropdown2').css ({
            "width": "47%"
         });

         $('.showDropdown1').css ({
            "width": "53%"
         });
      }

      $('.dropdown-menu li a').click ( (e) => {
         $('.dropdown-menu.show').css({"display": "block"});
      }) 
  }

$('.menu-item-color1 > a.dropdown-item').click(function() { return false; });
$('.menu-item-color2 > a.dropdown-item').click(function() { return false; });



$(window).load(function(){
   jQuery('.equal-height').matchHeight();
})

//sticky menu
$(document).on("scroll", function() {
   if ( $(window).scrollTop() > 100 ) {
      $('header').addClass('sticky');

      if ($(window).width() > 992) {
         $('body').css({'padding-top': '135px'});
      }
     
   } else {
      $('header').removeClass('sticky');
      $('body').css('padding-top', '0');
   }
});

//nav hamburger
$('.navbar-toggler').click(function(){
	$(this).toggleClass('open');
});


//home - product carousel
$("#carouselProductsOTC").carousel({
   interval: false
});

$("#carouselProductsSup").carousel({
   interval: false
});

$('.products-btn-otc').click( () => {
   $('#carouselProductsSUP').css('display', 'none');
   $('#carouselProductsOTC').css('display', 'block');
   $( '.products-btn-otc' ).addClass('active');
   $( '.products-btn-sup' ).removeClass('active');
});

$('.products-btn-sup').click( () => {
   $('#carouselProductsOTC').css('display', 'none');
   $('#carouselProductsSUP').css('display', 'block');
   $( '.products-btn-sup' ).addClass('active');
   $( '.products-btn-otc' ).removeClass('active');
});

if( !$('.footer-blog-item').length ) {
   console.log('works');
   $('.site-footer').addClass("hide-bg");
}

// ------------------- vitamins slider mobile

if( $('.vitamins-item').length ) {
   $('.vitamins-item').eq(0).addClass('active');

   $('.vitamins-nav .nav-dot').click( (e) => {
      $('.vitamins-nav .nav-dot').removeClass("active");
      let clicked = $(e.target);
      clicked.addClass("active");

      if ( $('.vitamins-nav .nav-dot').eq(0).hasClass('active') ) {
         $('.vitamins-item').removeClass('active');
         $('.vitamins-item').eq(0).addClass('active');
      }

      if ( $('.vitamins-nav .nav-dot').eq(1).hasClass('active') ) {
         $('.vitamins-item').removeClass('active');
         $('.vitamins-item').eq(1).addClass('active');
      }

      if ( $('.vitamins-nav .nav-dot').eq(2).hasClass('active') ) {
         $('.vitamins-item').removeClass('active');
         $('.vitamins-item').eq(2).addClass('active');
      }

      if ( $('.vitamins-nav .nav-dot').eq(3).hasClass('active') ) {
         $('.vitamins-item').removeClass('active');
         $('.vitamins-item').eq(3).addClass('active');
      }

      if ( $('.vitamins-nav .nav-dot').eq(4).hasClass('active') ) {
         $('.vitamins-item').removeClass('active');
         $('.vitamins-item').eq(4).addClass('active');
      }

      if ( $('.vitamins-nav .nav-dot').eq(5).hasClass('active') ) {
         $('.vitamins-item').removeClass('active');
         $('.vitamins-item').eq(5).addClass('active');
      }

   });


   document.getElementById('vitamins').addEventListener('touchstart', handleTouchStartVitamins, false);
   document.getElementById('vitamins').addEventListener('touchmove', handleTouchMoveVitamins, false);

   var xDown = null;
   var yDown = null;

   function getTouchesVitamins(evt) {
   return evt.touches ||             // browser API
            evt.originalEvent.touches; // jQuery
   }

   function handleTouchStartVitamins(evt) {
      const firstTouch = getTouchesVitamins(evt)[0];
      xDown = firstTouch.clientX;
      yDown = firstTouch.clientY;
   };

   function handleTouchMoveVitamins(evt) {
      if ( ! xDown || ! yDown ) {
         return;
      }

      var xUp = evt.touches[0].clientX;
      var yUp = evt.touches[0].clientY;

      var xDiff = xDown - xUp;
      var yDiff = yDown - yUp;

      if ( Math.abs( xDiff ) > Math.abs( yDiff ) ) {/*most significant*/
         if ( xDiff > 0 ) {
               /* left swipe */

               let itemActive = $( '.vitamins-item.active' );
               let nextItem = $( '.vitamins-item.active').parent().next().children('.vitamins-item');

               let dotActive = $('.vitamins-nav .nav-dot.active');
               let nextDot = $('.vitamins-nav .nav-dot.active').next();

               if ( !($( '.vitamins-item' ).eq(5).hasClass('active') ) ) {

                  itemActive.removeClass('active');
                  nextItem.addClass('active');

                  dotActive.removeClass('active');
                  nextDot.addClass('active');
               }


         } else {
               /* right swipe */

               let itemActive = $( '.vitamins-item.active' );
               let prevItem = $( '.vitamins-item.active').parent().prev().children('.vitamins-item');

               let dotActive = $('.vitamins-nav .nav-dot.active');
               let prevDot = $('.vitamins-nav .nav-dot.active').prev();

               if ( !($( '.vitamins-item' ).eq(0).hasClass('active') ) ) {

                  itemActive.removeClass('active');
                  prevItem.addClass('active');

                  dotActive.removeClass('active');
                  prevDot.addClass('active');
               }

         }
      } else {
         if ( yDiff > 0 ) {
               /* up swipe */
         } else {
               /* down swipe */
         }
      }
      /* reset values */
      xDown = null;
      yDown = null;
   };


   setInterval( () => {

      let itemActive = $( '.vitamins-item.active' );
      let nextItem = $( '.vitamins-item.active').parent().next().children('.vitamins-item');

      let dotActive = $('.vitamins-nav .nav-dot.active');
      let nextDot = $('.vitamins-nav .nav-dot.active').next();

      if ( $( '.vitamins-item' ).eq(5).hasClass('active') ) {
         itemActive.removeClass('active');
         $( '.vitamins-item' ).eq(0).addClass('active');

         dotActive.removeClass('active');
         $('.vitamins-nav .nav-dot').eq(0).addClass('active');

      } else {
         itemActive.removeClass('active');
         nextItem.addClass('active');

         dotActive.removeClass('active');
         nextDot.addClass('active');
      }


   }, 3500);
};

// ------------------- products page

if ( $('.products').length ) {
   $('.products-btn-otc').click( () => {
      $('.products-wrapper-sup').removeClass('active');
      $('.products-wrapper-otc').addClass('active')
   });

   $('.products-btn-sup').click( () => {
      $('.products-wrapper-otc').removeClass('active');
      $('.products-wrapper-sup').addClass('active')
   });
}

if (window.location.href.indexOf("sup") > -1) {
   $('.products-wrapper-otc').removeClass('active');
   $('.products-wrapper-sup').addClass('active');
   $( '.products-btn-sup' ).addClass('active');
   $( '.products-btn-otc' ).removeClass('active');
}

// slider footer blog
$('.footer-blog-inner-products').slick({
   slidesToShow: 3,
   slidesToScroll: 1,
   infinite: true,
   arrows: true,
   prevArrow: $('.footer-blog-arrows-products .footer-blog-arrow-prev'),
   nextArrow: $('.footer-blog-arrows-products .footer-blog-arrow-next'),
   responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
        }
      },
   ]
});

$('.footer-blog-inner-articles').slick({
   slidesToShow: 3,
   slidesToScroll: 1,
   infinite: true,
   arrows: true,
   prevArrow: $('.footer-blog-arrows-articles .footer-blog-arrow-prev'),
   nextArrow: $('.footer-blog-arrows-articles .footer-blog-arrow-next'),
   responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
        }
      },
   ]
});

});

// ------------------- dosage
let dose1 = '400 UI';
let dose2 = '400-600 UI';
let dose3 = '600-1000 UI';
let dose4 = '800-2000 UI';
let dose5 = '800-2000 UI';
let dose6 = '2000-4000 UI';


let text1 = 'Suplementację rozpocząć od pierwszych dni życia, niezależnie od sposobu karmienia noworodka / niemowlęcia';
let text2 = 'W zależności od dziennej podaży witaminy D z diety';
let text3 = 'W przypadku opalania się bez zastosowania filtrów słonecznych z odkrytymi ramionami i nogami przez co najmniej 15 min między godziną 10.00 a 15.00 , suplementacja w okresie od maja do września nie jest konieczna, choć nadal zalecana i bezpieczna; <br><br> jeżeli powyższe wytyczne dotyczące nasłonecznienia nie są spełnione, w zależności od masy ciała i dziennej podaży witaminy D z diety suplementację należy prowadzić przez cały rok';

let text4 = 'W przypadku opalania się bez zastosowania filtrów słonecznych z odkrytymi ramionami i nogami przez co najmniej 15 min między godziną 10.00 a 15.00 , suplementacja w okresie od maja do września nie jest konieczna, choć nadal zalecana i bezpieczna; <br><br> jeżeli powyższe wytyczne dotyczące nasłonecznienia nie są spełnione, w zależności od masy ciała i dziennej podaży witaminy D z diety suplementację należy prowadzić przez cały rok';

let text5 = 'W zależności od masy ciała i dziennej podaży witaminy D z diety suplementację należy prowadzić przez cały rok';
let text6 = 'W zależności od masy ciała i dziennej podaży witaminy D z diety suplementację należy prowadzić przez cały rok';


$('.dosage-line').click(function(e){
   $('.dosage-slider-show').removeClass("dosage-slider-hide");

   var offset = $(this).offset();
   var relativeX = (e.pageX - offset.left);

   let width = $(this).width();
   let step1 = (width/100) * 8;
   let step2Left = (width/100) * 8;
   let step2Right = (width/100) * 16;
   let step3Left = (width/100) * 16;
   let step3Right = (width/100) * 40;
   let step4Left = (width/100) * 40;
   let step4Right = (width/100) * 65;
   let step5Left = (width/100) * 65;
   let step5Right = (width/100) * 85;
   let step6Left = (width/100) * 85;
   let step6Right = (width/100) * 100;


   let clear = () => {
      //$('.dosage-slider-inner').css("opacity", "0");
      $('.dosage-slider-inner').removeClass("dosage-slider-show");
      $('.dosage-calc .dosage-info-box .dosage-number').css({'opacity': 0});
      $('.dosage-calc .dosage-info-box .dosage-info-text').css({'opacity': 0});
      $('.dosage-checkbox').removeClass('show');
   }

   let fadeIn = () => {
      $('.dosage-calc .dosage-info-box .dosage-number').css({'opacity': 1}, 300);
      $('.dosage-calc .dosage-info-box .dosage-info-text').animate({'opacity': 1}, 300);
   }

   // 1
   if( relativeX < step1 ) {
      clear();
      $('.dosage-slider-1').addClass("dosage-slider-show");
      $('.dosage-number').text(dose1);
      $('.dosage-info-text').html(text1);
      fadeIn();
   }

   // 2
   if( relativeX > step2Left && relativeX < step2Right){
      clear();
      $('.dosage-slider-2').addClass("dosage-slider-show");
      $('.dosage-number').text(dose2);
      $('.dosage-info-text').html(text2);
      fadeIn();
   }

   // 3
   if( relativeX > step3Left && relativeX < step3Right){
      clear();
      $('.dosage-slider-3').addClass("dosage-slider-show");
      $('.dosage-number').text(dose3);
      $('.dosage-info-text').html(text3);
      fadeIn();
   }

   // 4
   if( relativeX > step4Left && relativeX < step4Right){
      clear();
      $('.dosage-slider-4').addClass("dosage-slider-show");
      $('.dosage-number').text(dose4);
      $('.dosage-info-text').html(text4);
      fadeIn();
   }

   // 5
   if( relativeX > step5Left && relativeX < step5Right){
      clear();
      $('.dosage-slider-5').addClass("dosage-slider-show");
      $('.dosage-number').text(dose5);
      $('.dosage-info-text').html(text5);
      fadeIn();
   }

   // 6
   if( relativeX > step6Left && relativeX < step6Right){
      clear();
      $('.dosage-slider-6').addClass("dosage-slider-show");
      $('.dosage-number').text(dose6);
      $('.dosage-info-text').html(text6);
      fadeIn();
   }

});

$('.dosage-pregnant').click( () => {

   // $('.dosage-slider-inner').each(function() {
   //    if ($(this).hasClass('dosage-slider-show')) {
   //       actualDose = this;
   //       console.log(this);
   //    }
   // })

   $('.dosage-slider-show').addClass("dosage-slider-hide");
   $('.dosage-checkbox').toggleClass('show');

   let textPregnant = 'Przyjmowana dawka musi być ustalana po konsultacji z lekarzem';
   let dosePregnant = '2000 UI';
 

   if( $('.dosage-checkbox').hasClass('show') ) {
      $('.dosage-number').text(dosePregnant);
      $('.dosage-info-text').html(textPregnant);
   } else {

      $('.dosage-slider-show').removeClass("dosage-slider-hide");

      $('.dosage-slider-inner').each(function() {
         if ($(this).hasClass('dosage-slider-show')) {

            if ( $(this).hasClass('dosage-slider-1')) {
               $('.dosage-number').text(dose1);
               $('.dosage-info-text').html(text1);
            }

            if ( $(this).hasClass('dosage-slider-2')) {
               $('.dosage-number').text(dose2);
               $('.dosage-info-text').html(text2);
            }

            if ( $(this).hasClass('dosage-slider-3')) {
               $('.dosage-number').text(dose3);
               $('.dosage-info-text').html(text3);
            }

            if ( $(this).hasClass('dosage-slider-4')) {
               $('.dosage-number').text(dose4);
               $('.dosage-info-text').html(text4);
            }

            if ( $(this).hasClass('dosage-slider-5')) {
               $('.dosage-number').text(dose5);
               $('.dosage-info-text').html(text5);
            }

            if ( $(this).hasClass('dosage-slider-6')) {
               $('.dosage-number').text(dose6);
               $('.dosage-info-text').html(text6);
            }
         }
     });
   }

   

});


// ------------------- produkt multi label - suplement
$( '.product-single-header--multispec' ).append( '<p class="multispec--label">Suplementy diety</p>' );


// ------------------- footer products boxes - border
   $('.footer-blog-inner-products .box-category:contains("Suplement")').css({
      'border': '1px solid #71B800',
      'width': 'auto',
      'padding': '5px',
      'right': '49px'
   })


